import React, {useState, useRef, useEffect} from 'react';
import Button from '../Utils/Button';

import './style.scss'


const ImageUpload = ({id, name, setImage,onChange, providerImage}) => {
    const [imageBase64, setImageBase64] = useState('');
    const fileInputRef = useRef(null);

    useEffect(()=>{
        if(providerImage){
            setImageBase64(providerImage)
        }
    },[])

    const handleImageUpload = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setImageBase64(base64String);
                setImage(base64String)
            };

            reader.readAsDataURL(file);
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    return (
        <div>
            <input
                id={id}
                name={name}
                type="file"
                accept="image/jpeg, image/png"
                style={{ display: 'none' }}
                ref={fileInputRef}
                onChange={(e)=> {
                    handleImageUpload(e)
                    onChange(e)
                }}
            />
            <Button  className='button__charlie' onClick={handleButtonClick}>
               Upload Your logo
            </Button>
            {imageBase64 && (
                <div className={'image_upload_preview'}>
                    <img
                        src={ imageBase64}
                        alt="Uploaded"
                        style={{ maxWidth: '100%', maxHeight: '50px' }}
                    />
                </div>
            )}
        </div>
    );
};

export default ImageUpload;
